import { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  title: 'CRM System',
  layout: 'mix',
  navTheme: 'light',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  waterMarkProps: undefined,
  menu: {
    locale: true,
  },
  token: {},
  siderMenuType: 'sub',
  splitMenus: false,
  logo: 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg',
  links: [],
  headerHeight: 48,
  pwa: true,
  headerTitleRender: false,
};

export default Settings;
